import {
    isEqual as _isEqual,
} from '@lodash';
import StoreUtil from '@app/store/StoreUtil';
import { ILottoState } from '@app/store/modules/ui/lotto/types';
import {
    SET_FAVOURITE,
    DELETE_FAVOURITE,
    SET_RANDOM_NUMBERS_AMOUNT,
    SET_FAVOURITES_SAVING,
    SET_FAVOURITES,
    SET_SELECTED_FAVOURITES,
    SET_ARE_FAVOURITES_FETCHED_UPON_LOGIN,
    UPDATE_TIMESTAMP,
    SET_SELECTED_SIDEBAR_COMPONENT,
    SET_IS_LOADING,
} from '@store/modules/ui/lotto/mutationTypes';
import Vue from 'vue';

export default {
    [SET_FAVOURITE]: (
        state: ILottoState,
        { favourite, lottoId }: { favourite: number[], lottoId: number }
    ) => {
        if (!state.favourites[lottoId]) {
            Vue.set(state.favourites as any, lottoId, [favourite]);
        } else {
            if (state.favourites[lottoId].some((existingFavs) => _isEqual(existingFavs, favourite))) {
                return;
            }

            state.favourites[lottoId].push(favourite);
        }
    },
    [DELETE_FAVOURITE]: (
        state: ILottoState,
        { favouriteIndex, lottoId }: { favouriteIndex: number, lottoId: number },
    ) => {
        state.favourites[lottoId].splice(favouriteIndex, 1);
        if (!state.favourites[lottoId]) {
            delete state.favourites[lottoId];
        }
    },
    [SET_FAVOURITES_SAVING]: StoreUtil.createSimpleMutator('areFavouritesSaving'),
    [SET_FAVOURITES]: StoreUtil.createSimpleMutator('favourites'),
    [SET_ARE_FAVOURITES_FETCHED_UPON_LOGIN]: StoreUtil.createSimpleMutator('areFavouritesFetchedUponLogin'),
    [SET_SELECTED_FAVOURITES]: StoreUtil.createSimpleMutator('selectedFavourites'),
    [SET_RANDOM_NUMBERS_AMOUNT]: StoreUtil.createSimpleMutator('randomNumbersAmount'),
    [UPDATE_TIMESTAMP]: (state: ILottoState) => state.timestamp = Date.now(),
    [SET_SELECTED_SIDEBAR_COMPONENT]: StoreUtil.createToggleMutator('selectedSidebarComponent'),
    [SET_IS_LOADING]: StoreUtil.createSimpleMutator('isLoading'),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/store/modules/ui/lotto/mutations.ts